// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root___R38d","name":"Header_name__ok3EL","birthday":"Header_birthday__1mEga","skeleton":"Header_skeleton__yRUCz"};